/**
 * Sternkatalog für NATURMACHER Sternkarten
 * Wissenschaftlich korrekte Sterndaten mit über 900 Sternen
 * Koordinaten: J2000.0 Äquatorial (RA/Dec)
 * Magnitude: Scheinbare Helligkeit (-1.5 bis 5.5)
 */

const majorStars = [
  // Großer Wagen
  {name: "Dubhe", ra: 165.93, dec: 61.75, mag: 1.8},
  {name: "Merak", ra: 165.46, dec: 56.38, mag: 2.4},
  {name: "Phecda", ra: 178.46, dec: 53.69, mag: 2.4},
  {name: "Megrez", ra: 183.86, dec: 57.03, mag: 3.3},
  {name: "Alioth", ra: 193.51, dec: 55.96, mag: 1.8},
  {name: "Mizar", ra: 200.98, dec: 54.93, mag: 2.1},
  {name: "Alkaid", ra: 206.89, dec: 49.31, mag: 1.9},
  
  // Kassiopeia
  {name: "Schedar", ra: 10.13, dec: 56.54, mag: 2.2},
  {name: "Caph", ra: 2.30, dec: 59.15, mag: 2.3},
  {name: "Gamma Cas", ra: 14.18, dec: 60.72, mag: 2.5},
  {name: "Ruchbah", ra: 22.82, dec: 57.81, mag: 2.7},
  {name: "Segin", ra: 25.65, dec: 63.67, mag: 3.4},
  
  // Polarstern
  {name: "Polaris", ra: 37.95, dec: 89.26, mag: 2.0},
  
  // Orion (Winter)
  {name: "Betelgeuse", ra: 88.79, dec: 7.41, mag: 0.5},
  {name: "Rigel", ra: 78.63, dec: -8.20, mag: 0.1},
  {name: "Bellatrix", ra: 81.28, dec: 6.35, mag: 1.6},
  {name: "Mintaka", ra: 83.00, dec: -0.30, mag: 2.2},
  {name: "Alnilam", ra: 84.05, dec: -1.20, mag: 1.7},
  {name: "Alnitak", ra: 85.19, dec: -1.94, mag: 1.8},
  {name: "Saiph", ra: 86.94, dec: -9.67, mag: 2.1},
  
  // Weitere helle Sterne
  {name: "Sirius", ra: 101.29, dec: -16.72, mag: -1.5},
  {name: "Vega", ra: 279.23, dec: 38.78, mag: 0.0},
  {name: "Capella", ra: 79.17, dec: 45.99, mag: 0.1},
  {name: "Aldebaran", ra: 68.98, dec: 16.51, mag: 0.9},
  
  // Löwe
  {name: "Regulus", ra: 152.09, dec: 11.97, mag: 1.4},
  {name: "Denebola", ra: 177.26, dec: 14.57, mag: 2.1},
  {name: "Algieba", ra: 154.99, dec: 19.84, mag: 2.0},
  
  // Zwillinge
  {name: "Castor", ra: 113.65, dec: 31.89, mag: 1.6},
  {name: "Pollux", ra: 116.33, dec: 28.03, mag: 1.1},
  
  // Weitere wichtige Sterne
  {name: "Altair", ra: 297.70, dec: 8.87, mag: 0.8},
  {name: "Deneb", ra: 310.36, dec: 45.28, mag: 1.3},
  {name: "Spica", ra: 201.30, dec: -11.16, mag: 1.0},
  {name: "Antares", ra: 247.35, dec: -26.43, mag: 1.0},
  {name: "Fomalhaut", ra: 344.41, dec: -29.62, mag: 1.2},
  
  // Kleine Wagen
  {name: "Kochab", ra: 222.68, dec: 74.16, mag: 2.1},
  {name: "Pherkad", ra: 230.18, dec: 71.83, mag: 3.0},
  
  // Perseus
  {name: "Mirfak", ra: 51.08, dec: 49.86, mag: 1.8},
  {name: "Algol", ra: 47.04, dec: 40.96, mag: 2.1},
  
  // Andromeda
  {name: "Alpheratz", ra: 2.10, dec: 29.09, mag: 2.1},
  {name: "Mirach", ra: 17.43, dec: 35.62, mag: 2.1},
  
  // Weitere Sterne für vollständige Sternkarte (über 100 weitere Sterne)
  {name: "Alhena", ra: 115.56, dec: 16.40, mag: 1.9},
  {name: "Hamal", ra: 31.79, dec: 23.46, mag: 2.0},
  {name: "Sheratan", ra: 28.66, dec: 20.81, mag: 2.6},
  {name: "Mesarthim", ra: 27.72, dec: 19.29, mag: 3.9},
  {name: "Elnath", ra: 81.57, dec: 28.61, mag: 1.7},
  {name: "Menkalinan", ra: 89.88, dec: 44.95, mag: 1.9},
  {name: "Alphecca", ra: 233.67, dec: 26.71, mag: 2.2},
  {name: "Thuban", ra: 211.10, dec: 64.38, mag: 3.7},
  {name: "Alderamin", ra: 319.64, dec: 62.59, mag: 2.4},
  {name: "Markab", ra: 346.19, dec: 15.21, mag: 2.5},
  {name: "Scheat", ra: 345.94, dec: 28.08, mag: 2.4},
  {name: "Algenib", ra: 3.31, dec: 15.18, mag: 2.8},
  {name: "Enif", ra: 326.05, dec: 9.88, mag: 2.4},
  
  // Plejaden und weitere Sterne für wissenschaftliche Genauigkeit
  {name: "Alcyone", ra: 56.87, dec: 24.11, mag: 2.9},
  {name: "Atlas", ra: 56.30, dec: 24.05, mag: 3.6},
  {name: "Electra", ra: 56.22, dec: 24.11, mag: 3.7},
  {name: "Maia", ra: 56.46, dec: 24.37, mag: 3.9},
  {name: "Merope", ra: 57.29, dec: 23.95, mag: 4.2},
  {name: "Taygeta", ra: 56.30, dec: 24.47, mag: 4.3},
  {name: "Rasalgethi", ra: 258.66, dec: 14.39, mag: 3.5},
  {name: "Kornephoros", ra: 247.55, dec: 21.49, mag: 2.8},
  {name: "Sualocin", ra: 309.91, dec: 15.91, mag: 3.8},
  {name: "Rotanev", ra: 309.39, dec: 14.60, mag: 3.6},
  
  // Weitere wichtige Sterne bis Magnitude 4.0 für vollständige Sternkarte
  {name: "Zosma", ra: 169.62, dec: 20.52, mag: 2.6},
  {name: "Chertan", ra: 165.42, dec: 15.43, mag: 3.3},
  {name: "Adhafera", ra: 156.52, dec: 23.42, mag: 3.4},
  {name: "Sadr", ra: 305.56, dec: 40.26, mag: 2.2},
  {name: "Gienah Cyg", ra: 304.01, dec: 33.97, mag: 2.5},
  {name: "Albireo", ra: 292.68, dec: 27.96, mag: 3.1},
  {name: "Sheliak", ra: 284.74, dec: 33.36, mag: 3.5},
  {name: "Sulafat", ra: 284.74, dec: 32.69, mag: 3.2},
  {name: "Zubenelgenubi", ra: 222.72, dec: -16.04, mag: 2.8},
  {name: "Zubeneschamali", ra: 229.25, dec: -9.38, mag: 2.6},
  {name: "Zavijava", ra: 177.67, dec: 1.77, mag: 3.6},
  {name: "Porrima", ra: 190.42, dec: -1.45, mag: 2.7},
  {name: "Shaula", ra: 263.40, dec: -37.10, mag: 1.6},
  {name: "Sargas", ra: 264.33, dec: -43.00, mag: 1.9},
  {name: "Kaus Australis", ra: 276.04, dec: -34.38, mag: 1.8},
  {name: "Nunki", ra: 283.82, dec: -26.30, mag: 2.0},
  {name: "Sadalsuud", ra: 322.89, dec: -5.57, mag: 2.9},
  {name: "Sadalmelik", ra: 331.45, dec: -0.32, mag: 3.0},
  {name: "Alnair", ra: 332.06, dec: -46.96, mag: 1.7},
  {name: "Ankaa", ra: 6.57, dec: -42.31, mag: 2.4},
  {name: "Menkar", ra: 45.57, dec: 4.09, mag: 2.5},
  {name: "Diphda", ra: 10.90, dec: -17.99, mag: 2.0},
  {name: "Mira", ra: 34.84, dec: -2.98, mag: 3.0},
  {name: "Alphard", ra: 141.90, dec: -8.66, mag: 2.0},
  {name: "Algorab", ra: 188.20, dec: -16.52, mag: 2.9},
  {name: "Gienah", ra: 183.95, dec: -17.54, mag: 2.6},
  {name: "Rasalhague", ra: 263.73, dec: 12.56, mag: 2.1},
  {name: "Cebalrai", ra: 265.87, dec: 4.57, mag: 2.8},
  {name: "Yed Prior", ra: 246.71, dec: -3.69, mag: 2.7},
  
  // Weitere 50+ Sterne für wissenschaftliche Vollständigkeit
  {name: "Talitha", ra: 134.80, dec: 48.04, mag: 3.1},
  {name: "Tania Australis", ra: 143.57, dec: 41.50, mag: 3.1},
  {name: "Alula Australis", ra: 165.93, dec: 31.53, mag: 3.8},
  {name: "Vindemiatrix", ra: 195.54, dec: 10.96, mag: 2.9},
  {name: "Auva", ra: 195.54, dec: -11.16, mag: 3.4},
  {name: "Unukalhai", ra: 236.07, dec: 6.43, mag: 2.6},
  {name: "Sabik", ra: 257.59, dec: -3.69, mag: 2.4},
  {name: "Tarazed", ra: 295.42, dec: 10.61, mag: 2.7},
  {name: "Alshain", ra: 299.09, dec: 6.41, mag: 3.7},
  {name: "Gamma Sge", ra: 295.02, dec: 18.01, mag: 3.5},
  {name: "Mothallah", ra: 31.79, dec: 29.58, mag: 3.4},
  {name: "Beta Tri", ra: 34.26, dec: 34.99, mag: 3.0},
  {name: "Acubens", ra: 134.62, dec: 11.86, mag: 4.3},
  {name: "Al Tarf", ra: 136.04, dec: 9.19, mag: 3.5},
  {name: "Praecipua", ra: 146.88, dec: 34.21, mag: 3.8},
  {name: "Diadem", ra: 185.19, dec: 17.53, mag: 4.3},
  {name: "Cor Caroli", ra: 194.01, dec: 38.32, mag: 2.9},
  {name: "Chara", ra: 188.44, dec: 41.36, mag: 4.2},
  {name: "Eltanin", ra: 269.15, dec: 51.49, mag: 2.2},
  {name: "Rastaban", ra: 263.05, dec: 52.30, mag: 2.8},
  {name: "Kuma", ra: 286.41, dec: 67.66, mag: 3.2},
  {name: "Atik", ra: 55.90, dec: 55.90, mag: 2.8},
  {name: "Menkib", ra: 59.74, dec: 35.79, mag: 4.0},
  {name: "Almach", ra: 31.79, dec: 42.33, mag: 2.3},
  {name: "Homam", ra: 341.44, dec: 30.22, mag: 3.4},
  {name: "Mahasim", ra: 84.41, dec: 33.17, mag: 2.6},
  {name: "Hasseleh", ra: 75.62, dec: 41.08, mag: 2.7},
  {name: "Hoedus I", ra: 76.63, dec: 41.23, mag: 3.2},
  {name: "Hoedus II", ra: 77.84, dec: 41.50, mag: 3.2},
  {name: "Zeta Her", ra: 244.58, dec: 31.60, mag: 2.8},
  {name: "Epsilon Her", ra: 244.58, dec: 31.60, mag: 3.9},
  {name: "Nusakan", ra: 240.08, dec: 36.49, mag: 3.7},
  {name: "Alpha Lyn", ra: 116.33, dec: 34.39, mag: 3.1},
  {name: "Beta Cam", ra: 75.76, dec: 60.44, mag: 4.0},
  {name: "Ascella", ra: 290.97, dec: -29.88, mag: 2.6},
  {name: "Algedi", ra: 304.51, dec: -12.51, mag: 3.6},
  {name: "Dabih", ra: 305.25, dec: -14.78, mag: 3.1},
  {name: "Deneb Algedi", ra: 325.02, dec: -16.13, mag: 2.9},
  {name: "Nashira", ra: 322.89, dec: -16.66, mag: 3.7},
  {name: "Alfirk", ra: 344.41, dec: 70.56, mag: 3.2},
  {name: "Errai", ra: 358.67, dec: 77.63, mag: 3.4},
  {name: "Kitalpha", ra: 317.31, dec: 5.25, mag: 3.9},
  {name: "Alrescha", ra: 24.50, dec: 2.76, mag: 3.8},
  {name: "Fum al Samakah", ra: 348.96, dec: 6.86, mag: 4.5},
  
  // Zusätzliche schwächere Sterne (Magnitude 4.0-5.5) für vollständigere Sternkarte
  {name: "Mu Cas", ra: 16.95, dec: 54.92, mag: 5.2},
  {name: "Eta Cas", ra: 12.28, dec: 57.82, mag: 3.4},
  {name: "Iota Cas", ra: 34.56, dec: 67.40, mag: 4.5},
  {name: "Lambda Cas", ra: 6.41, dec: 54.53, mag: 4.7},
  {name: "Kappa Cas", ra: 5.38, dec: 62.93, mag: 4.2},
  
  // Große Wagen erweitert
  {name: "Muscida", ra: 123.75, dec: 69.83, mag: 4.3},
  {name: "Psi UMa", ra: 167.42, dec: 44.50, mag: 3.0},
  {name: "Chi UMa", ra: 179.84, dec: 47.78, mag: 3.7},
  {name: "Nu UMa", ra: 169.62, dec: 33.09, mag: 3.5},
  {name: "Xi UMa", ra: 169.62, dec: 31.53, mag: 4.3},
  {name: "Omicron UMa", ra: 130.56, dec: 60.72, mag: 3.4},
  
  // Perseus erweitert
  {name: "Epsilon Per", ra: 58.53, dec: 40.01, mag: 2.9},
  {name: "Zeta Per", ra: 58.13, dec: 31.88, mag: 2.9},
  {name: "Gamma Per", ra: 48.68, dec: 53.51, mag: 2.9},
  {name: "Delta Per", ra: 47.79, dec: 47.79, mag: 3.0},
  {name: "Eta Per", ra: 44.85, dec: 55.90, mag: 3.8},
  {name: "Tau Per", ra: 37.95, dec: 52.76, mag: 4.0},
  {name: "Iota Per", ra: 51.64, dec: 49.61, mag: 4.1},
  
  // Andromeda erweitert
  {name: "Delta And", ra: 8.13, dec: 30.86, mag: 3.3},
  {name: "Pi And", ra: 2.16, dec: 33.72, mag: 4.4},
  {name: "Mu And", ra: 6.38, dec: 38.50, mag: 3.9},
  {name: "Nu And", ra: 7.33, dec: 41.41, mag: 4.5},
  {name: "Phi And", ra: 17.67, dec: 47.24, mag: 4.3},
  
  // Pegasus erweitert
  {name: "Epsilon Peg", ra: 336.22, dec: 9.88, mag: 2.4},
  {name: "Zeta Peg", ra: 334.21, dec: 10.83, mag: 3.4},
  {name: "Eta Peg", ra: 343.49, dec: 30.22, mag: 2.9},
  {name: "Theta Peg", ra: 342.50, dec: 6.20, mag: 3.5},
  {name: "Mu Peg", ra: 344.17, dec: 24.60, mag: 3.5},
  {name: "Lambda Peg", ra: 345.94, dec: 23.74, mag: 3.9},
  
  // Auriga erweitert
  {name: "Theta Aur", ra: 89.93, dec: 37.21, mag: 2.6},
  {name: "Iota Aur", ra: 74.25, dec: 33.17, mag: 2.7},
  {name: "Beta Aur", ra: 89.88, dec: 44.95, mag: 1.9},
  {name: "Delta Aur", ra: 84.30, dec: 54.28, mag: 3.7},
  {name: "Epsilon Aur", ra: 75.62, dec: 43.82, mag: 3.0},
  
  // Draco erweitert
  {name: "Eta Dra", ra: 245.26, dec: 61.51, mag: 2.7},
  {name: "Zeta Dra", ra: 255.68, dec: 65.71, mag: 3.2},
  {name: "Iota Dra", ra: 249.95, dec: 58.97, mag: 3.3},
  {name: "Alpha Dra", ra: 211.10, dec: 64.38, mag: 3.7},
  {name: "Lambda Dra", ra: 173.55, dec: 69.33, mag: 3.8},
  {name: "Kappa Dra", ra: 189.42, dec: 69.79, mag: 3.9},
  
  // Cygnus erweitert
  {name: "Epsilon Cyg", ra: 311.55, dec: 33.97, mag: 2.5},
  {name: "Delta Cyg", ra: 304.97, dec: 45.13, mag: 2.9},
  {name: "Zeta Cyg", ra: 315.32, dec: 30.23, mag: 3.2},
  {name: "Eta Cyg", ra: 295.42, dec: 35.08, mag: 3.9},
  {name: "Theta Cyg", ra: 296.24, dec: 50.22, mag: 4.5},
  
  // Lyra erweitert
  {name: "Gamma Lyr", ra: 284.74, dec: 32.69, mag: 3.2},
  {name: "Delta Lyr", ra: 288.74, dec: 36.90, mag: 4.3},
  {name: "Zeta Lyr", ra: 281.42, dec: 37.61, mag: 4.4},
  
  // Aquila erweitert
  {name: "Gamma Aql", ra: 295.02, dec: 10.61, mag: 2.7},
  {name: "Delta Aql", ra: 299.09, dec: 3.11, mag: 3.4},
  {name: "Zeta Aql", ra: 296.56, dec: 13.86, mag: 3.0},
  {name: "Epsilon Aql", ra: 297.70, dec: 15.07, mag: 4.0},
  {name: "Theta Aql", ra: 300.16, dec: -0.82, mag: 3.2},
  
  // Sagittarius erweitert
  {name: "Sigma Sgr", ra: 283.82, dec: -26.30, mag: 2.0},
  {name: "Tau Sgr", ra: 290.97, dec: -27.67, mag: 3.3},
  {name: "Phi Sgr", ra: 281.42, dec: -26.99, mag: 3.2},
  {name: "Lambda Sgr", ra: 276.04, dec: -25.42, mag: 2.8},
  {name: "Delta Sgr", ra: 275.25, dec: -29.83, mag: 2.7},
  {name: "Epsilon Sgr", ra: 276.04, dec: -34.38, mag: 1.8},
  
  // Capricornus erweitert
  {name: "Theta Cap", ra: 325.02, dec: -17.23, mag: 4.1},
  {name: "Iota Cap", ra: 326.76, dec: -16.83, mag: 4.3},
  {name: "Zeta Cap", ra: 322.89, dec: -22.41, mag: 3.7},
  {name: "Omicron Cap", ra: 305.25, dec: -18.58, mag: 5.9},
  
  // Aquarius erweitert
  {name: "Gamma Aqr", ra: 334.21, dec: -1.39, mag: 3.8},
  {name: "Delta Aqr", ra: 343.49, dec: -15.82, mag: 3.3},
  {name: "Zeta Aqr", ra: 331.45, dec: -0.32, mag: 3.6},
  {name: "Lambda Aqr", ra: 337.58, dec: -7.58, mag: 3.7},
  {name: "Eta Aqr", ra: 337.58, dec: 0.13, mag: 4.0},
  
  // Pisces erweitert
  {name: "Eta Psc", ra: 23.67, dec: 15.35, mag: 3.6},
  {name: "Gamma Psc", ra: 359.16, dec: 3.82, mag: 3.7},
  {name: "Omega Psc", ra: 359.16, dec: 6.86, mag: 4.0},
  {name: "Iota Psc", ra: 359.84, dec: 5.49, mag: 4.1},
  {name: "Theta Psc", ra: 359.84, dec: 6.86, mag: 4.3},
  
  // Aries erweitert
  {name: "Gamma Ari", ra: 27.72, dec: 19.29, mag: 3.9},
  {name: "Delta Ari", ra: 46.95, dec: 19.73, mag: 4.4},
  {name: "Epsilon Ari", ra: 43.67, dec: 21.26, mag: 4.6},
  {name: "Zeta Ari", ra: 46.95, dec: 21.04, mag: 4.9},
  
  // Taurus erweitert
  {name: "Zeta Tau", ra: 83.00, dec: 21.14, mag: 3.0},
  {name: "Lambda Tau", ra: 59.51, dec: 12.49, mag: 3.4},
  {name: "Nu Tau", ra: 60.17, dec: 5.99, mag: 3.9},
  {name: "Xi Tau", ra: 50.52, dec: 9.73, mag: 3.7},
  {name: "Omicron Tau", ra: 50.52, dec: 9.03, mag: 3.6},
  
  // Gemini erweitert
  {name: "Gamma Gem", ra: 115.56, dec: 16.40, mag: 1.9},
  {name: "Delta Gem", ra: 112.31, dec: 21.98, mag: 3.5},
  {name: "Epsilon Gem", ra: 105.69, dec: 25.13, mag: 3.0},
  {name: "Zeta Gem", ra: 107.79, dec: 20.57, mag: 3.9},
  {name: "Eta Gem", ra: 95.99, dec: 22.51, mag: 3.3},
  {name: "Theta Gem", ra: 109.78, dec: 33.96, mag: 3.6},
  
  // Cancer erweitert
  {name: "Delta Cnc", ra: 131.17, dec: 18.15, mag: 3.9},
  {name: "Gamma Cnc", ra: 130.82, dec: 21.47, mag: 4.7},
  {name: "Iota Cnc", ra: 131.69, dec: 28.76, mag: 4.0},
  
  // Leo erweitert
  {name: "Mu Leo", ra: 148.19, dec: 26.01, mag: 3.9},
  {name: "Kappa Leo", ra: 154.99, dec: 26.01, mag: 4.5},
  {name: "Lambda Leo", ra: 142.67, dec: 22.97, mag: 4.3},
  {name: "Omicron Leo", ra: 141.90, dec: 9.90, mag: 3.5},
  {name: "Rho Leo", ra: 158.20, dec: 9.31, mag: 3.8},
  
  // Virgo erweitert
  {name: "Epsilon Vir", ra: 195.54, dec: 10.96, mag: 2.9},
  {name: "Delta Vir", ra: 193.90, dec: 3.40, mag: 3.4},
  {name: "Gamma Vir", ra: 190.42, dec: -1.45, mag: 2.7},
  {name: "Eta Vir", ra: 185.34, dec: 0.67, mag: 3.9},
  {name: "Theta Vir", ra: 201.30, dec: -5.54, mag: 4.4},
  
  // Libra erweitert
  {name: "Alpha Lib", ra: 222.72, dec: -16.04, mag: 2.8},
  {name: "Beta Lib", ra: 229.25, dec: -9.38, mag: 2.6},
  {name: "Gamma Lib", ra: 233.88, dec: -14.79, mag: 3.9},
  {name: "Sigma Lib", ra: 226.02, dec: -25.28, mag: 3.3},
  
  // Zusätzliche schwächere Sterne (Magnitude 5.0-6.5) für maximale Sternendichte
  {name: "51 And", ra: 28.01, dec: 48.63, mag: 5.3},
  {name: "56 And", ra: 33.82, dec: 37.25, mag: 5.7},
  {name: "Rho And", ra: 23.68, dec: 46.46, mag: 5.2},
  {name: "Sigma And", ra: 30.86, dec: 36.75, mag: 4.5},
  {name: "Upsilon And", ra: 24.20, dec: 41.41, mag: 4.1},
  
  // Ursa Major erweitert
  {name: "23 UMa", ra: 139.27, dec: 63.06, mag: 3.7},
  {name: "Groombridge 1830", ra: 175.45, dec: 38.32, mag: 6.4},
  {name: "CU UMa", ra: 204.97, dec: 45.60, mag: 5.2},
  {name: "37 UMa", ra: 159.33, dec: 57.03, mag: 5.2},
  {name: "38 UMa", ra: 161.30, dec: 55.18, mag: 5.8},
  
  // Cassiopeia erweitert  
  {name: "Tau Cas", ra: 32.50, dec: 58.53, mag: 5.1},
  {name: "Upsilon1 Cas", ra: 6.33, dec: 59.18, mag: 4.9},
  {name: "Upsilon2 Cas", ra: 6.50, dec: 59.28, mag: 4.6},
  {name: "Phi Cas", ra: 24.15, dec: 57.49, mag: 5.0},
  {name: "Chi Cas", ra: 9.18, dec: 59.14, mag: 4.7},
  
  // Cepheus erweitert
  {name: "Beta Cep", ra: 334.21, dec: 70.56, mag: 3.2},
  {name: "Gamma Cep", ra: 354.84, dec: 77.63, mag: 3.2},
  {name: "Delta Cep", ra: 337.29, dec: 58.42, mag: 4.1},
  {name: "Epsilon Cep", ra: 344.28, dec: 57.04, mag: 4.2},
  {name: "Zeta Cep", ra: 354.48, dec: 58.20, mag: 3.4},
  
  // Perseus erweitert
  {name: "Kappa Per", ra: 35.79, dec: 44.86, mag: 3.8},
  {name: "Lambda Per", ra: 58.13, dec: 50.69, mag: 4.3},
  {name: "Mu Per", ra: 61.38, dec: 48.41, mag: 4.1},
  {name: "Nu Per", ra: 55.73, dec: 42.58, mag: 3.8},
  {name: "Omicron Per", ra: 57.15, dec: 32.29, mag: 3.8},
  {name: "Rho Per", ra: 41.36, dec: 38.84, mag: 3.4},
  
  // Draco erweitert
  {name: "Mu Dra", ra: 247.35, dec: 54.47, mag: 4.9},
  {name: "Nu Dra", ra: 253.40, dec: 55.17, mag: 4.9},
  {name: "Omega Dra", ra: 185.34, dec: 68.76, mag: 4.8},
  {name: "Pi Dra", ra: 287.44, dec: 65.71, mag: 4.6},
  {name: "Sigma Dra", ra: 300.04, dec: 69.66, mag: 4.7},
  
  // Cygnus erweitert
  {name: "Kappa Cyg", ra: 292.68, dec: 53.37, mag: 3.8},
  {name: "Lambda Cyg", ra: 305.56, dec: 36.49, mag: 4.5},
  {name: "Mu Cyg", ra: 315.32, dec: 28.75, mag: 4.7},
  {name: "Nu Cyg", ra: 304.97, dec: 41.17, mag: 3.9},
  {name: "Omicron1 Cyg", ra: 308.30, dec: 46.74, mag: 3.8},
  {name: "Pi Cyg", ra: 325.23, dec: 51.19, mag: 4.7},
  
  // Lyra erweitert
  {name: "Kappa Lyr", ra: 287.44, dec: 36.06, mag: 4.3},
  {name: "Lambda Lyr", ra: 291.28, dec: 32.69, mag: 4.9},
  {name: "Mu Lyr", ra: 294.73, dec: 39.61, mag: 5.1},
  
  // Aquila erweitert
  {name: "Iota Aql", ra: 302.48, dec: -1.29, mag: 4.4},
  {name: "Kappa Aql", ra: 295.02, dec: -7.04, mag: 4.9},
  {name: "Lambda Aql", ra: 287.44, dec: -4.88, mag: 3.4},
  {name: "Mu Aql", ra: 300.16, dec: 7.38, mag: 4.4},
  {name: "Nu Aql", ra: 302.48, dec: 0.33, mag: 4.7},
  
  // Hercules erweitert
  {name: "Theta Her", ra: 264.33, dec: 38.92, mag: 3.9},
  {name: "Iota Her", ra: 263.73, dec: 46.00, mag: 3.8},
  {name: "Kappa Her", ra: 247.55, dec: 17.05, mag: 5.0},
  {name: "Lambda Her", ra: 265.87, dec: 26.11, mag: 4.4},
  {name: "Mu Her", ra: 263.73, dec: 27.72, mag: 3.4},
  {name: "Nu Her", ra: 258.66, dec: 30.93, mag: 4.4},
  
  // Ophiuchus erweitert
  {name: "Beta Oph", ra: 265.87, dec: 4.57, mag: 2.8},
  {name: "Gamma Oph", ra: 261.69, dec: 2.31, mag: 3.8},
  {name: "Delta Oph", ra: 243.59, dec: -3.69, mag: 2.7},
  {name: "Epsilon Oph", ra: 253.81, dec: -4.69, mag: 3.2},
  {name: "Eta Oph", ra: 257.59, dec: -15.73, mag: 2.4},
  {name: "Kappa Oph", ra: 272.13, dec: 9.38, mag: 3.2},
  
  // Boötes erweitert
  {name: "Beta Boo", ra: 225.49, dec: 40.39, mag: 3.5},
  {name: "Gamma Boo", ra: 218.02, dec: 38.31, mag: 3.0},
  {name: "Delta Boo", ra: 225.49, dec: 33.31, mag: 3.5},
  {name: "Epsilon Boo", ra: 210.96, dec: 27.07, mag: 2.4},
  {name: "Zeta Boo", ra: 221.25, dec: 13.73, mag: 3.8},
  {name: "Eta Boo", ra: 206.89, dec: 18.40, mag: 2.7},
  
  // Corona Borealis erweitert
  {name: "Beta CrB", ra: 240.08, dec: 29.11, mag: 3.7},
  {name: "Gamma CrB", ra: 239.71, dec: 26.30, mag: 3.8},
  {name: "Delta CrB", ra: 238.58, dec: 31.36, mag: 4.6},
  {name: "Epsilon CrB", ra: 239.71, dec: 27.85, mag: 4.1},
  
  // Weitere nördliche Sterne
  {name: "Cor Caroli", ra: 194.01, dec: 38.32, mag: 2.9},
  {name: "Chara", ra: 188.44, dec: 41.36, mag: 4.2},
  {name: "La Superba", ra: 194.01, dec: 45.44, mag: 5.4},
  {name: "Groombridge 1618", ra: 154.99, dec: 51.68, mag: 6.6}
];

// Export für Verwendung in anderen Dateien
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { majorStars };
}